import { useMemo as s } from "react";
const f = (e, t) => ({ filteredData: s(() => {
  if (!t)
    return e;
  const o = t.toLowerCase();
  return e.filter(
    (u) => u.body.some((r) => (r.sortValue ?? (typeof r.value == "string" ? r.value : "")).toLowerCase().includes(o))
  );
}, [e, t]) });
export {
  f as useTableFilter
};
